import axiosInstance from "../../../helpers/api";

export const getAllExams = (id) => {
  return axiosInstance.get(`/student/student_exams`);
};

export const getExamsByChapterID = (id) => {
  return axiosInstance.get(`/student/student_exams/${id}`);
};

export const getChapterExam = (id) => {
  return axiosInstance.get(`/student/student_exams/chapter_exams/${id}`);
};

export const getChapterExamById = (id) => {
  return axiosInstance.get(
    `/student/student_exams/chapter_exam_questions/${id}`
  );
};
export const getExamsByID = (id) => {
  return axiosInstance.get(`/student/exams/details/${id}`);
};

export const getExamQuestions = (id) => {
  return axiosInstance.get(`/student/student_exams/get_questions/${id}`);
};

export const getExamCorrection = (id) => {
  return axiosInstance.get(
    `/student/student_exams/get_questions_correction/${id}`
  );
};

export const sendAnswers = (formData) => {
  return axiosInstance.post("/student/student_exams/set_answers", formData);
};

export const sendChapterExamAnswers = (formData) => {
  return axiosInstance.post(
    "/student/student_exams/chapter_exam/set_answer",
    formData
  );
};

export const examRedo = (formData) => {
  return axiosInstance.post("/student/redo-exam-requests/request", formData);
};
